import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true, 
            themeCache: null,
        },
        themes: {
            light: {
                primary: '#002245',
                secondary: '#EE680B',

                'primary-100': '#EAECEF', 
                'primary-200': '#CCD3D9', 
                'primary-300': '#99A6B3', 
                'primary-400': '#66798C', 
                'primary-500': '#334C66',
                'primary-600': '#002245', 
                'primary-700': '#001B37', 
                'primary-800': '#001429', 
                'primary-900': '#000E1C',
                'primary-1000': '#00070E', 

                'secondary-100': '#FDF0E6', 
                'secondary-200': '#FAD1B3',
                'secondary-300': '#F6B380',
                'secondary-400': '#F2944D',
                'secondary-500': '#EE680B', 
                'secondary-600': '#D65D0A', 
                'secondary-700': '#BF5309',
                'secondary-800': '#A64908',
                'secondary-900': '#8C3D06',
                'secondary-1000': '#733205', 

                error: '#C62828',
                'error-soft': '#FFEBEE', 
                
                warning: '#E65100',
                'warning-soft': '#FFF3E0', 
                
                info: '#0288D1',
                'info-soft': '#E1F5FE', 
                
                success: '#2E7D32',
                'success-soft': '#E8F5E9', 

                background: '#F4F6F8', 
                surface: '#FFFFFF',
                
                neutral: '#000',
                'neutral-100': '#F5F5F5',
                'neutral-200': '#EEEEEE',
                'neutral-300': '#E0E0E0',
                'neutral-400': '#BDBDBD',
                'neutral-500': '#9E9E9E',
                'neutral-600': '#757575',
                'neutral-700': '#616161',
                'neutral-800': '#424242',
                'neutral-900': '#212121',

            }
        }
    }
});
